/**
 * @module settingGroups/NullHanding/NullUISelector
 * @description 空值处理方式单选 — 字段 `null_ui`
 *
 * 状态管理：useSettingState('null_ui')
 */

import React, { useCallback, useMemo } from 'react';
import { useIntl } from 'umi';
import { Select } from 'tea-component';
import { useSettingState } from '../../context';

const NullUISelector: React.FC = () => {
  const { formatMessage } = useIntl();
  const { value, setValue } = useSettingState('null_ui');

  const options = useMemo(
    () => [
      {
        value: 'break',
        text: formatMessage({ id: 'dbl_chart_null_ui_break' }),
      },
      {
        value: '0',
        text: formatMessage({ id: 'dbl_chart_null_ui_zero' }),
      },
      {
        value: 'ignore',
        text: formatMessage({ id: 'dbl_chart_null_ui_ignore' }),
      },
    ],
    [formatMessage],
  );

  const handleChange = useCallback(
    (nextValue: string) => {
      setValue(nextValue);
    },
    [setValue],
  );

  return (
    <div className="dbl-chart-setting-row">
      <span className="dbl-lable-gray-font">
        {formatMessage({ id: 'dbl_chart_null_ui_label' })}
      </span>
      <Select
        className="dbl-sort-by-panel__select"
        appearance="button"
        listWidth={232}
        matchButtonWidth
        value={value}
        options={options}
        onChange={handleChange}
      />
    </div>
  );
};

export default React.memo(NullUISelector);
